import { LicenseManager } from "ag-grid-enterprise/main"

LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID_LICENSE || "")
